import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { usePlaidQueries } from "../query-context";
import { GetInvestmentHoldingsResponse, PlaidConnection, PlaidDeal, Security } from "../../store/types/plaid/api";
import { IApiServiceError } from "store";

export const useGetInvestmentHoldings = (
  accessToken?: string | null
): UseQueryResult<GetInvestmentHoldingsResponse, IApiServiceError> => {
  const { getInvestmentHoldings } = usePlaidQueries();

  return useQuery(["plaid-get-investment-holdings", accessToken], () =>
    accessToken ? getInvestmentHoldings(accessToken) : Promise.resolve(null)
  );
};

export const useGetConnections = (): UseQueryResult<PlaidConnection[], IApiServiceError> => {
  const { getConnections } = usePlaidQueries();

  return useQuery(["plaid-connections"], getConnections);
};

export const useGetConnectionDeals = (connectionId: number): UseQueryResult<PlaidDeal[], IApiServiceError> => {
  const { getConnectionDeals } = usePlaidQueries();

  return useQuery(["plaid-connection-deals", connectionId], () => getConnectionDeals(connectionId));
};

export const useGetSecurities = (): UseQueryResult<Security[], IApiServiceError> => {
  const { getSecurities } = usePlaidQueries();

  return useQuery(["plaid-securities"], () => getSecurities());
};